import React, { FC, useMemo, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { fetchInlineNoticePageAction } from 'actions/uninotice/uniNoticeAction'
import { FontSize } from 'common-constants/sizes'
import { DefaultLoader } from 'components/presentational/AnimatedWatch/AnimatedWatch'
import { CommonNoticeView } from 'components/uninotice/CommonNoticeView'
import {
  UniNoticeContext,
  UniNoticeContextValue,
} from 'components/uninotice/UniNotice.context'
import { UniNoticeId } from 'components/uninotice/uninotice.types'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { uniNoticeReducer } from 'reducers/uniNoticeReducer'

const ExternalLinkNotice: FC = () => {
  useReducersInsert({ uniNoticeReducer: uniNoticeReducer })
  const dispatch = useDispatch()

  const { inlineNoticePage, query } = useShallowEqualSelector(
    ({ uniNoticeReducer: { inlineNoticePage }, systemReducer: { query } }) => ({
      inlineNoticePage,
      query,
    })
  )

  const handlePrimaryClick = () => {
    if (inlineNoticePage) {
      window.close()
    }
  }

  useEffect(() => {
    const externalLink = decodeURIComponent(query.link)

    if (
      externalLink.startsWith('http://') ||
      externalLink.startsWith('https://')
    ) {
      dispatch(
        fetchInlineNoticePageAction(
          UniNoticeId.external_url_click_confirmation,
          {
            external_url: externalLink,
          }
        )
      )
    } else {
      dispatch(fetchInlineNoticePageAction(UniNoticeId.external_url_is_invalid))
    }
  }, [dispatch, query.link])

  const value = useMemo<UniNoticeContextValue>(() => ({ notSafe: true }), [])

  if (!inlineNoticePage) {
    return <DefaultLoader />
  }

  return (
    <Desc>
      <div style={{ height: '40px', width: '100%' }} />
      <UniNoticeContext.Provider value={value}>
        <CommonNoticeView
          notice={inlineNoticePage}
          viewWithoutBorder={true}
          primaryButtonPortalContainer={null}
          onActionClick={handlePrimaryClick}
        />
      </UniNoticeContext.Provider>
    </Desc>
  )
}

export default ExternalLinkNotice

export const Desc = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: ${FontSize.titleSubGiftCategory}px;
  font-family: Arial, sans-serif;
`
